module.exports = __webpack_public_path__ + "static/img/video-top-shdow@2x.b61d4d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common-img/video-top-shdow@2x.png
// module id = pNyJ
// module chunks = 17